import React from "react";
import dummyImage from "assets/images/common/others/minorImage.png";
interface Props {
  user: any;
}
const PersonalInformation: React.FC<Props> = ({ user }) => {
  return (
    <div className="">
      <div className="my-8 grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            First Name
          </span>
          <span className="text-xs text-tertiaryText">  {user?.user?.firstName || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Last Name
          </span>
          <span className="text-xs text-tertiaryText">  {user?.user?.lastName || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Date of Birth
          </span>
          <span className="text-xs text-tertiaryText">{user?.user?.dob || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">Email</span>
          <span className="text-xs text-tertiaryText">
            {user?.user?.email || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">Gender</span>
          <span className="text-xs text-tertiaryText">{user?.user?.gender || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Phone Number
          </span>
          <span className="text-xs text-tertiaryText">{user?.user?.phone || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Physical Address
          </span>
          <span className="text-xs text-tertiaryText">
            {user?.user?.address || "-"}
          </span>
        </div>

        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">City</span>
          <span className="text-xs text-tertiaryText"> {user?.user?.city || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">State</span>
          <span className="text-xs text-tertiaryText">{user?.user?.state || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Zip Code
          </span>
          <span className="text-xs text-tertiaryText">{user?.user?.zipCode || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Member Since
          </span>
          <span className="text-xs text-tertiaryText">  {user?.profiles?.attendee?.createdAt
            ? new Intl.DateTimeFormat("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            }).format(new Date(user.profiles.attendee.createdAt))
            : "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Skills & Strength
          </span>
          <span className="text-xs text-tertiaryText">
            {user?.profiles?.ambassador?.skills?.length
              ? user.profiles.ambassador.skills.join(", ")
              : "-"}
          </span>
        </div>


        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Level of Engagement
          </span>
          <span className="text-xs text-tertiaryText">{user?.profiles?.ambassador?.engagementLevel || "-"}</span>
        </div>

        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Level of Commitment
          </span>
          <span className="text-xs text-tertiaryText">
            {user?.profiles?.ambassador?.commitmentLength || "-"}
          </span>
        </div>
        <div className="col-span-2 flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Mission Statement
          </span>
          <span className="text-xs text-tertiaryText">
            {user?.profiles?.ambassador?.mission || "-"}
          </span>
        </div>
      </div>

      <div className=" my-6">
        <h1 className="text-base font-bold text-primaryText">Referral</h1>
        <div className="mt-4 flex flex-wrap sm:gap-40 items-center gap-4">
          <div className="flex flex-col gap-4">
            <span className="flex gap-3 items-center">
              <img
                className="w-10 h-10 rounded-full"
                src={dummyImage}
                alt="dummyImage"
              />
              <p className="text-base font-bold text-primaryText">
                Bertha Valdez
              </p>
            </span>
            <span className="text-xs text-tertiaryText">{user?.profiles?.ambassador?.referralCode || "-"}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInformation;
